var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { memo, useCallback } from 'react';
import styled from 'styled-components';
var NavSelect = function (_a) {
    var data = _a.data, onLayerIndex = _a.onLayerIndex, setOnLayerIndex = _a.setOnLayerIndex, setCurrentCategory = _a.setCurrentCategory, index = _a.index, prevDataSetting = _a.prevDataSetting, setIdFn = _a.setIdFn, setIndexFn = _a.setIndexFn, currentCategory = _a.currentCategory, timerOffFn = _a.timerOffFn, flagIdIndexFn = _a.flagIdIndexFn, prevIndex = _a.prevIndex, prevId = _a.prevId;
    var enter = useCallback(function () {
        timerOffFn(); // 타이머 종료
        setOnLayerIndex(index);
    }, [index]);
    var leave = useCallback(function () {
        if (flagIdIndexFn()) {
            setTimeout(function () {
                prevDataSetting('mouseLeave');
            }, 1000);
        }
        else {
            setOnLayerIndex(-1);
        }
    }, [prevIndex, prevId]);
    var cateClick = useCallback(function (id, fVal) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            /**
             * fVal === 0 이전 데이터에 값 추가
             * */
            if (!fVal) {
                setIdFn(Number(currentCategory));
                setIndexFn(index);
            }
            setCurrentCategory(id);
            setOnLayerIndex(index + 1);
            return [2 /*return*/];
        });
    }); }, [index]);
    return (React.createElement("li", { onMouseEnter: enter, onMouseLeave: leave },
        React.createElement("span", { className: "txt arrow" }, data.cate_name),
        onLayerIndex === index && (React.createElement("ul", { className: "nav_layer" }, data.child.map(function (v) {
            return (React.createElement(List, { key: v.cate_id }, v.cate_id.slice(0, 1) === "2" && v.child_count === 0
                ? (React.createElement("a", { href: "".concat(v.lnk_url), target: "_blank" }, v.cate_name)) : (v.cate_id.slice(0, 1) !== "2" && v.child_count === 0 || v.f_clk
                ? (React.createElement("a", { href: "".concat(process.env.REACT_APP_SHOPPING_URL, "/list/").concat(v.cate_id), target: "_blank" }, v.cate_name)) : (React.createElement("button", { type: "button", onClick: function () { return cateClick(v.cate_id, v.f_clk); } }, v.cate_name)))));
        })))));
};
var List = styled.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    button {\n        background: none;\n        border: none;\n    }\n"], ["\n    button {\n        background: none;\n        border: none;\n    }\n"])));
export default memo(NavSelect);
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/nav/nav_select.tsx
// module id = 177
// module chunks = 0